<template>
  <q-card class="q-pa-md">
    <div class="row">
      <q-space />
      <div class="row">
        <q-select
          dense
          outlined
          class="q-mr-sm"
          v-model="transactionModel"
          :options="transactionList"
          label="Transaction Type"
          style="width: 210px; padding-bottom: 10px"
        />

        <q-select
          v-if="displayAll"
          outlined
          v-model="selectedSector"
          :options="optionSectors"
          dense
          label="Choose sector"
          single
          input-debounce="0"
          option-label="name"
          option-value="symbol"
          class="q-mr-sm"
          style="width: 210px; padding-bottom: 10px"
          :menu-absolute="true"
        />
        <!-- <q-separator spaced inset vertical color="orange" class="q-mb-lg" /> -->
        <q-select
          :menu-absolute="true"
          outlined
          class="q-mb-md"
          :class="this.$q.dark.mode === true ? '' : 'bg-grey-1'"
          v-model="selectedSymbol"
          single
          dense
          clearable
          use-input
          input-debounce="0"
          :options="options"
          option-value="symbol"
          option-label="symbol"
          emit-value
          stack-label
          map-options
          label="Select Stock"
          @filter="filterFn"
        >
          <template v-slot:no-option>
            <q-item>
              <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
          </template>
        </q-select>

        <div class="q-px-xs col-sm-">
          <q-input
            dense
            filled
            v-model="from_date"
            mask="date"
            :rules="['date']"
            hint="Enter From Date"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date v-model="from_date">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="q-px-xs col-sm-">
          <q-input
            dense
            filled
            v-model="to_date"
            mask="date"
            :rules="['date']"
            hint="Enter To Date"
          >
            <template v-slot:append>
              <q-icon name="event" class="cursor-pointer">
                <q-popup-proxy
                  cover
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date v-model="to_date">
                    <div class="row items-center justify-end">
                      <q-btn v-close-popup label="Close" color="primary" flat />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-icon>
            </template>
          </q-input>
        </div>
        <div class="q-pa-xs text-end col-sm-">
          <q-btn
            class="q-pa-sm"
            square
            color="blue-5"
            icon="search"
            @click="loadData()"
            size="sm"
          >
            <q-tooltip class="bg-primary">Search</q-tooltip>
          </q-btn>
        </div>
      </div>
    </div>
    <q-table
      :class="
        this.$q.dark.mode === true
          ? 'table-sticky-header-column-dark '
          : displayAll
          ? 'table-sticky-header-column table-column-color-all'
          : 'table-sticky-header-column table-column-color1'
      "
      dense
      :rows="
        displayAll ? brokerAnalyticsDataComputed : tableDataWithPercentComputed
      "
      :columns="
        displayAll
          ? transactionModel === 'Purchase'
            ? purchaseColumns
            : sellColumns
          : transactionModel === 'Purchase'
          ? purchaseColumnsSymbol
          : sellColumnsSymbol
      "
      binary-state-sort
      :pagination="{
        rowsPerPage: 20,
      }"
      separator="cell"
      :filter="filterQuery"
      :filter-method="filterBrokerAnalytics"
    >
      <template v-slot:top-left>
        <div class="row">
          <span>
            <q-input
              v-if="displayAll"
              class="q-mr-md live-search"
              bordered
              dense
              debounce="300"
              v-model="filterSymbol"
              placeholder="Filter Symbols"
            >
            </q-input>
          </span>
          <span>
            <q-input
              bordered
              dense
              debounce="300"
              v-model="filterBuyer"
              placeholder="Filter Broker"
            >
            </q-input>
          </span>
          <span
            v-if="!displayAll"
            class="q-py-sm q-pl-sm-md text-weight-medium"
          >
            Stock {{ selectedSymbol }}
          </span>
        </div>
      </template>
      <template v-slot:top-right>
        <q-checkbox
          v-if="displayAll"
          class="q-mr-sm"
          v-model="myStocks"
          color="blue-5"
          keep-color
          label="My Signals"
        >
          <q-tooltip class="bg-primary">My Signals Only</q-tooltip>
        </q-checkbox>
      </template>
      <template v-slot:body-cell-symbol="props">
        <q-td :props="props">
          <q-item
            dense
            clickable
            :to="{
              path: '/stock-profile',
              query: { symbol: props.value },
            }"
          >
            <div class="col">
              {{ props.value }}
              <q-tooltip>{{
                allStocks.find((stock) => stock.symbol == props.value)?.name
              }}</q-tooltip>
            </div>
          </q-item>
        </q-td>
      </template>
    </q-table>
  </q-card>
</template>
<script>
import { ref, computed, watch, onMounted } from "vue";
import { useQuasar, LocalStorage } from "quasar";
import { useStore } from "vuex";

import useUtils from "src/use/utils";

import useData from "src/use/data";
import useCore from "src/use/core";
import useMembership from "src/use/membership";

export default {
  name: "SymbolWiseBrokerAnalyticsPro",
  components: {},
  setup() {
    const {
      brokerAnalytics,
      brokerAnalyticsWithSymbol,
      brokerAnalyticsAvgSum,
    } = useData();
    const { amountConversion } = useUtils();
    const store = useStore();
    const { allStock } = useCore();
    const { getPackage } = useMembership();

    const $q = useQuasar();

    const packageDetail = ref({});
    const selectedSymbol = ref(null);
    const displayAll = ref(true);
    const descending = ref(true);

    const transactionModel = ref("Purchase");
    const transactionList = ref(["Purchase", "Selling"]);

    const allStocks = ref(store.state.core.allStocks);

    const options = ref([]);
    const optionSectors = ref([
      {
        id: 0,
        symbol: "All Sectors",
        name: "All Sectors",
        label: "All Sectors",
      },
      { id: 1, symbol: "BANKING", name: "Banking" },
      { id: 2, symbol: "DEVBANK", name: "Dev Banks" },
      { id: 3, symbol: "FINANCE", name: "Finance" },
      { id: 4, symbol: "HOTELS", name: "Hotels" },
      { id: 5, symbol: "HYDRO", name: "Hydropower" },
      { id: 6, symbol: "INVESTMENT", name: "Investment" },
      { id: 7, symbol: "LIFEINSU", name: "Life Insurance" },
      { id: 8, symbol: "MANUFACTURE", name: "Manufacturing" },
      { id: 9, symbol: "MICROFINANCE", name: "Microfinance" },
      { id: 10, symbol: "NONLIFEINSU", name: "NonLife" },
      { id: 11, symbol: "OTHERS", name: "Others" },
      { id: 12, symbol: "TRDIND", name: "Tradings" },
    ]);
    const selectedSector = ref(optionSectors.value[0]);

    let myStocks = ref(false);
    const myStocksList = ref([]);
    const sectorSymbols = ref([]);

    const brokerAnalyticsData = ref([]);
    const tableDataWithPercent = ref([]);
    const sumAmt = ref(null);

    const to_date = ref(store.state.market.asOf.replaceAll("/", "-"));
    const parsedDate = new Date(to_date.value);
    const from_date = ref(
      new Date(
        parsedDate.getFullYear(),
        parsedDate.getMonth(),
        parsedDate.getDate() - 7
      )
        .toISOString()
        .substring(0, 10)
    );

    (async () => {
      try {
        if (store.state.authenticate.isAuthenticated) {
          if (LocalStorage.getItem("package") != null) {
            packageDetail.value = LocalStorage.getItem("package");
            myStocksList.value = packageDetail.value.stocks;
          } else {
            const packageRes = await getPackage();
            packageDetail.value = packageRes.data;
            loading.value = false;
          }
        }
      } catch (err) {
        packageDetail.value = null;
      }
    })();

    const columns = [
      {
        name: "symbol",
        required: true,
        label: "Symbol",
        field: "symbol",
        sortable: true,
        format: (val, row) => {
          return val;
        },
        align: "left",
      },
      {
        name: "buyer",
        label: "Buyer",
        field: "buyer",
        sortable: true,
        format: (val, row) => {
          return val;
        },
        align: "center",
      },
      {
        name: "buy_quantity",
        label: "Buy Qnty",
        field: (row) => row.buy_quantity,

        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "avg_buy_amount",
        label: "Avg Buy Amt",
        field: "avg_buy_amount",
        field: (row) => row.avg_buy_amount,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "avg_buy_rate",
        label: "Avg Buy Rate",
        field: "net_buy_rate",
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "seller",
        label: "Seller",
        field: "seller",
        sortable: true,
        format: (val, row) => {
          return val;
        },
        align: "center",
      },
      {
        name: "sell_quantity",
        label: "Sell Qnty",
        field: (row) => row.sell_quantity,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "avg_sell_amount",
        label: "Avg Sell Amt",
        field: (row) => row.avg_sell_amount,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "avg_sell_rate",
        label: "Avg Sell Rate",
        field: "net_sell_rate",
        sortable: true,
        format: (val) => amountConversion(val),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
      {
        name: "net_amount",
        label: "Net Amt",
        field: "net_amount",
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },

      {
        name: "net_rate",
        label: "Net Rate",
        field: "net_rate",
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
    ];

    const purchaseColumns = [
      ...columns.slice(0, 9),
      {
        name: "net_quantity",
        label: "Net Holding",
        field: (row) => row.net_quantity,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      ...columns.slice(9),
    ];
    const sellColumns = [
      ...columns.slice(0, 9),
      {
        name: "net_quantity",
        label: "Net Supply",
        field: (row) => row.net_quantity,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      ...columns.slice(9),
    ];

    const columnsSymbol = [
      {
        name: "buyer",
        required: true,
        label: "Buyer",
        field: "buyer",
        sortable: true,
        format: (val, row) => {
          return val;
        },
        align: "center",
      },

      {
        name: "buy_quantity",
        label: "Buy Qnty",
        field: (row) => row.buy_quantity,

        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "avg_buy_amount",
        label: "Avg Buy Amt",
        field: "avg_buy_amount",
        field: (row) => row.avg_buy_amount,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "net_buy_rate",
        label: "Net Buy Rate",
        field: "net_buy_rate",
        sortable: true,
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },
      {
        name: "seller",
        required: true,
        label: "Seller",
        field: "seller",
        sortable: true,
        format: (val, row) => {
          return val;
        },
        align: "center",
      },
      {
        name: "sell_quantity",
        label: "Sell Qnty",
        field: (row) => row.sell_quantity,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "avg_sell_amount",
        label: "Avg Sell Amt",
        field: (row) => row.avg_sell_amount,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "net_sell_rate",
        label: "Net Sell Rate",
        field: "net_sell_rate",
        sortable: true,
        format: (val) => amountConversion(val),

        align: "center",
      },
      {
        name: "net_amount",
        label: "Net Amt",
        field: "net_amount",
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
      {
        name: "amount_percent",
        label: "Net Amt %",
        field: "amount_percent",
        sortable: true,
        format: (val) => amountConversion(val),
        format: (val, row) => {
          return parseFloat(val).toFixed(2);
        },
        align: "center",
      },

      {
        name: "net_rate",
        label: "Net Rate",
        field: "net_rate",
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },
    ];

    const purchaseColumnsSymbol = [
      ...columnsSymbol.slice(0, 8),
      {
        name: "net_quantity",
        label: "Net Holding",
        field: (row) => row.net_quantity,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },

      ...columnsSymbol.slice(8),
    ];
    const sellColumnsSymbol = [
      ...columnsSymbol.slice(0, 8),
      {
        name: "net_quantity",
        label: "Net Supply",
        field: (row) => row.net_quantity,
        sortable: true,
        format: (val) => amountConversion(val),
        align: "center",
      },

      ...columnsSymbol.slice(8),
    ];

    const filterBuyer = ref("");
    const filterSymbol = ref("");

    const filterQuery = computed({
      get() {
        return {
          symbol: filterSymbol.value?.toUpperCase(),
          buyer: filterBuyer.value?.toLowerCase(),
        };
      },
      set(newValue) {
        filterSymbol.value = newValue.symbol;
        filterBuyer.value = newValue.buyer;
      },
    });

    const filterBrokerAnalytics = (rows, terms, cols, getCellValue) => {
      return rows.filter((row) => {
        return (
          (filterQuery.value.symbol === "" ||
            row.symbol.toUpperCase().includes(filterQuery.value.symbol)) &&
          (filterQuery.value.buyer === "" ||
            row.buyer?.toLowerCase() === filterQuery.value.buyer)
        );
      });
    };

    function loadData() {
      $q.loading.show({});
      if (selectedSymbol.value === null) {
        brokerAnalytics(
          from_date.value.replaceAll("/", "-"),
          to_date.value.replaceAll("/", "-")
        )
          .then((res) => {
            brokerAnalyticsData.value = res.data;
            $q.loading.hide();
            displayAll.value = true;
          })
          .catch((error) => {
            $q.loading.hide();
          });
      } else {
        brokerAnalyticsAvgSum(
          from_date.value.replaceAll("/", "-"),
          to_date.value.replaceAll("/", "-")
        )
          .then((res) => {
            sumAmt.value = res.data.filter(
              (i) => i.symbol === selectedSymbol.value
            );
            $q.loading.hide();
          })
          .catch(() => {
            // $q.loading.hide();
          })
          .then((res) => {
            tableDataWithPercent.value = [];
            brokerAnalyticsWithSymbol(
              from_date.value.replaceAll("/", "-"),
              to_date.value.replaceAll("/", "-"),
              selectedSymbol.value
            )
              .then((res) => {
                $q.loading.hide();
                brokerAnalyticsData.value = res.data;
                displayAll.value = false;

                const sum = sumAmt.value[0].sum;

                tableDataWithPercent.value = brokerAnalyticsData.value.map(
                  (item) => ({
                    ...item,
                    amount_percent: (item.net_amount / sum) * 100,
                  })
                );
              })
              .catch((error) => {
                $q.loading.hide();
              });
          });
      }
    }

    function filterData(sector, data, filterArray) {
      const sortMultiplier = transactionModel.value === "Purchase" ? -1 : 1;
      data.sort((a, b) => sortMultiplier * (a.net_amount - b.net_amount));

      if (sector.id === 0) {
        return !myStocks.value
          ? data
          : data.filter((i) => filterArray.includes(i.symbol));
      } else {
        sectorSymbols.value = allStocks.value
          .filter((i) => i.sector == sector.id)
          .map((i) => i.symbol);

        return !myStocks.value
          ? data.filter((i) => sectorSymbols.value.includes(i.symbol))
          : data
              .filter((i) => sectorSymbols.value.includes(i.symbol))
              .filter((i) => filterArray.includes(i.symbol));
      }
    }

    const brokerAnalyticsDataComputed = computed(() =>
      filterData(
        selectedSector.value,
        brokerAnalyticsData.value,
        myStocksList.value
      )
    );
    const tableDataWithPercentComputed = computed(() =>
      filterData(
        selectedSector.value,
        tableDataWithPercent.value,
        myStocksList.value
      )
    );

    const paginationBuy = ref({
      rowsPerPage: 20,
      sortBy: "net_amount",
      descending: true,
    });

    const paginationSell = ref({
      rowsPerPage: 20,
      sortBy: "net_amount",
      descending: false,
    });

    const dynamicPagination = computed(() =>
      descending.value ? paginationBuy.value : paginationSell.value
    );

    onMounted(() => {
      loadData();
    });

    return {
      allStocks,
      loadData,

      from_date,
      to_date,

      selectedSector,
      optionSectors,
      myStocks,
      descending,
      dynamicPagination,

      brokerAnalyticsData,
      brokerAnalyticsDataComputed,
      tableDataWithPercent,
      tableDataWithPercentComputed,

      columns,
      purchaseColumns,
      sellColumns,
      columnsSymbol,
      purchaseColumnsSymbol,
      sellColumnsSymbol,

      selectedSymbol,

      options,
      displayAll,

      filterSymbol,
      filterBuyer,

      filterQuery,
      filterBrokerAnalytics,

      transactionList,
      transactionModel,

      filterFn(val, update) {
        if (val === "") {
          update(() => {
            options.value = allStocks.value;
          });
          return;
        }

        update(() => {
          const needle = val.toLowerCase();
          options.value = allStocks.value.filter((v) => {
            return v.symbol.toLowerCase().indexOf(needle) > -1;
          });
        });
      },
    };
  },
};
</script>
